import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alt", "src", "data-src", "fillFrame", "fillParent", "onError", "onLoad", "transparentBackground", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { alpha } from 'utils/ui/colors';
import { fadeIn } from 'styles/animations';
import { fillParent } from 'styles/mixins';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled.div.attrs({
  role: 'presentation'
}).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['fillFrame', 'fillParent'].includes(prop);
  }
}).withConfig({
  displayName: "ImageWithLoader__Wrapper",
  componentId: "sc-qxodop-0"
})(["display:block;", " border-radius:inherit;"], function (p) {
  return p.fillParent && fillParent;
});
var LoadingIndicator = styled.div.withConfig({
  displayName: "ImageWithLoader__LoadingIndicator",
  componentId: "sc-qxodop-1"
})(["", " background-color:", ";animation:", " 750ms ease-out alternate infinite;"], fillParent, alpha('white', 0.15), fadeIn);
var StyledImage = styled.img.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['fillFrame', 'transparentBackground'].includes(prop);
  }
}).withConfig({
  displayName: "ImageWithLoader__StyledImage",
  componentId: "sc-qxodop-2"
})(["position:relative;display:block;width:100%;height:100%;object-fit:", ";", " transition:opacity 250ms linear;animation:", " 0.25s ease-in;"], function (p) {
  return p.fillFrame ? 'cover' : 'contain';
}, function (p) {
  return !p.transparentBackground && css(["background-color:white;"]);
}, fadeIn);
var Picture = styled.picture.withConfig({
  displayName: "ImageWithLoader__Picture",
  componentId: "sc-qxodop-3"
})(["border-radius:inherit;"]);
function ImageWithLoader(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    src = _ref.src,
    dataSrc = _ref['data-src'],
    _ref$fillFrame = _ref.fillFrame,
    fillFrame = _ref$fillFrame === void 0 ? true : _ref$fillFrame,
    _ref$fillParent = _ref.fillParent,
    fillParent = _ref$fillParent === void 0 ? true : _ref$fillParent,
    onError = _ref.onError,
    onLoad = _ref.onLoad,
    _ref$transparentBackg = _ref.transparentBackground,
    transparentBackground = _ref$transparentBackg === void 0 ? false : _ref$transparentBackg,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasErrored = _useState4[0],
    setErrored = _useState4[1];
  var handleErrored = function handleErrored(e) {
    setErrored(true);
    onError === null || onError === void 0 || onError(e);
  };
  var handleLoaded = function handleLoaded(e) {
    setLoading(false);
    onLoad === null || onLoad === void 0 || onLoad(e);
  };
  var source = src || dataSrc;
  var formats = [];

  // Only attach formats when the source is a link to our picture API
  if (source !== null && source !== void 0 && source.startsWith('/api/picture/')) {
    if (!/\bf_(original|png|jpeg|webp|svg|avif)\b/.test(source)) {
      formats.push('avif', 'webp');
      if (src) {
        src += ',f_original';
      }
      if (dataSrc) {
        dataSrc += ',f_original';
      }
    }
  }
  return /*#__PURE__*/_jsxs(Wrapper, {
    fillParent: fillParent,
    fillFrame: fillFrame,
    children: [isLoading && !hasErrored && /*#__PURE__*/_jsx(LoadingIndicator, {}), !hasErrored && /*#__PURE__*/_jsxs(Picture, {
      children: [formats.map(function (format) {
        return /*#__PURE__*/_jsx("source", {
          srcSet: "".concat(source, ",f_").concat(format),
          type: "image/".concat(format)
        }, format);
      }), /*#__PURE__*/_jsx(StyledImage, _objectSpread(_objectSpread({}, otherProps), {}, {
        src: src,
        "data-src": dataSrc,
        alt: alt,
        fillFrame: fillFrame,
        transparentBackground: transparentBackground,
        style: {
          opacity: isLoading ? '0' : '1'
        },
        onLoad: handleLoaded,
        onError: handleErrored,
        role: "img"
      }))]
    }), children]
  });
}
export default ImageWithLoader;